import { motion } from "framer-motion";

export const GithubIcon = () => {
  return (
    <motion.svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="100%"
      viewBox="0 0 800 800"
      enableBackground="new 0 0 800 800"
      className="home-social-icon"
      whileHover={{ scale: 1.15 }}
    >
      <motion.path
        className="git-icon"
        fill="#777777"
        opacity="1.000000"
        stroke="none"
        d="
M801.000000,370.000000 
	C801.000000,397.354218 801.000000,424.708466 800.658569,452.191986 
	C799.881348,453.164124 799.177368,453.969086 799.052063,454.855804 
	C797.978760,462.453552 797.491211,470.167267 795.916077,477.654388 
	C791.917847,496.659454 788.269653,515.798279 782.981201,534.458435 
	C773.917908,566.438660 760.039917,596.438416 743.055542,625.045349 
	C728.820435,649.021667 712.364990,671.355225 693.498962,691.783508 
	C677.899963,708.674255 661.638245,725.108276 642.817322,738.460571 
	C625.355225,750.848755 607.752075,763.286804 589.059204,773.618896 
	C571.688782,783.219971 552.786743,790.045593 534.603699,798.192871 
	C533.531799,798.673279 532.858704,800.043762 532.000000,801.000000 
	C524.979065,801.000000 517.958130,801.000000 510.843079,800.795898 
	C510.360260,800.067261 510.084473,799.347534 509.565796,799.047363 
	C501.991058,794.663696 499.887451,787.821228 499.932434,779.504578 
	C500.100922,748.341125 500.203186,717.174377 499.909546,686.012756 
	C499.774109,671.638916 499.275665,657.212097 497.818420,642.923889 
	C496.526855,630.260681 492.393402,618.193481 485.102936,607.524353 
	C481.468872,602.206116 477.421753,597.170227 473.475952,591.892273 
	C474.013763,591.611328 474.555664,591.108398 475.138184,591.055908 
	C493.017822,589.443481 510.511505,585.976868 527.817688,581.148926 
	C559.508301,572.308167 587.770508,557.897583 610.327332,533.294128 
	C624.078552,518.295227 633.947571,501.138275 641.059814,482.192169 
	C651.469910,454.460876 655.016418,425.498230 655.770752,396.216248 
	C656.107483,383.145142 655.069458,369.806580 652.705994,356.947693 
	C648.184265,332.346588 638.238892,309.874420 622.653748,290.011627 
	C618.625977,284.878296 613.132324,280.830109 616.628967,271.724396 
	C622.387878,256.727600 623.027832,240.619934 622.159119,224.422058 
	C621.222351,206.956543 617.341980,190.291031 611.389465,174.000900 
	C610.939697,172.770172 609.293823,171.215393 608.120972,171.142242 
	C603.141357,170.831680 598.028564,170.378815 593.149963,171.150772 
	C577.668579,173.600494 562.765747,178.435165 548.968872,185.729874 
	C533.479065,193.919693 518.626526,203.313370 503.460724,212.121185 
	C502.382477,212.747391 500.913788,213.358078 499.785675,213.142761 
	C484.168396,210.162033 468.646790,206.615646 452.960938,204.078827 
	C440.684540,202.093384 428.238556,200.613235 415.822235,200.159592 
	C395.661987,199.423019 375.430420,199.503403 355.462799,203.052078 
	C338.821075,206.009689 322.259308,209.422974 305.684326,212.745224 
	C302.680054,213.347397 300.067078,213.833878 297.222778,211.777374 
	C281.105621,200.124344 264.064056,189.988098 245.678162,182.350372 
	C230.597626,176.085739 215.312820,170.636917 198.501709,170.803619 
	C192.771667,170.860443 190.460251,172.813080 188.876511,177.938431 
	C182.536926,198.454758 178.237946,219.118805 179.835739,240.854614 
	C180.691620,252.497864 181.963837,263.931580 186.034348,274.870453 
	C187.602264,279.083984 185.927399,281.800629 183.646606,284.976776 
	C177.279968,293.842773 170.428543,302.488220 165.165176,311.994080 
	C151.439819,336.782654 146.255646,363.852844 146.055771,391.965851 
	C146.010071,398.392975 146.643936,404.826355 147.007263,411.254486 
	C147.313950,416.680389 147.303741,422.158447 148.091782,427.516663 
	C150.715408,445.356079 153.891769,463.077301 160.020142,480.150360 
	C167.966187,502.287231 179.714233,522.167236 196.407333,538.671753 
	C210.669632,552.772827 227.279541,563.710083 245.925446,571.575684 
	C266.100494,580.086182 286.975464,585.758484 308.572479,589.018494 
	C315.057617,589.997375 321.517059,591.146606 328.623627,592.323059 
	C327.581238,593.668396 327.163452,594.362000 326.602600,594.908875 
	C313.016327,608.157532 306.968750,624.953674 304.055206,643.160278 
	C303.465515,646.845215 301.393921,648.703247 298.206818,649.942139 
	C283.256805,655.753662 267.905182,658.817993 251.737289,658.115112 
	C241.934998,657.689026 232.726456,655.423828 223.963699,651.392029 
	C207.069031,643.618713 195.514847,630.192871 186.223694,614.565247 
	C173.804886,593.677063 157.031311,578.272644 132.828156,572.441345 
	C125.835190,570.756531 118.664619,570.766174 111.854881,573.665588 
	C107.067574,575.703979 105.886154,578.082214 108.496880,581.799377 
	C111.114136,585.525696 114.346420,588.976318 117.860306,591.881042 
	C123.497459,596.540833 130.108749,600.101868 135.389069,605.098694 
	C150.265503,619.176392 159.462173,636.933044 167.088226,655.708557 
	C174.984451,675.149231 189.039154,688.923950 207.840775,698.053528 
	C220.316620,704.111511 233.468292,706.835815 247.252533,708.248779 
	C260.560730,709.612854 273.459717,708.181091 286.458557,706.238708 
	C291.517426,705.482788 296.571655,704.695984 301.997681,703.866699 
	C301.997681,731.221558 302.195587,757.868103 301.841858,784.507385 
	C301.764923,790.300842 298.802887,795.451904 293.170624,798.437134 
	C292.252289,798.923889 291.713959,800.127625 291.000000,801.000000 
	C284.645599,801.000000 278.291199,801.000000 271.807526,800.715820 
	C271.212555,799.982666 270.823792,799.301941 270.270050,799.118164 
	C244.104141,790.432434 219.548248,778.341553 196.067215,764.000000 
	C172.571655,749.649597 150.523407,733.350525 130.752579,714.149719 
	C121.480591,705.145081 112.368706,695.915833 103.874863,686.185547 
	C94.497620,675.443176 85.379951,664.390259 77.092140,652.798462 
	C59.924622,628.786987 44.852184,603.417175 34.161633,575.850037 
	C26.273876,555.510315 19.191040,534.775024 13.233603,513.794617 
	C7.773290,494.564911 4.239683,474.782806 2.911086,454.716614 
	C2.870586,454.104919 1.663310,453.570465 1.000004,453.000000 
	C1.000000,425.645782 1.000000,398.291534 1.346138,370.806702 
	C2.126579,369.663239 2.818362,368.683960 2.955457,367.632385 
	C4.370694,356.777191 5.086017,345.791534 7.171531,335.070831 
	C11.786212,311.348846 17.884533,287.986237 26.320110,265.281921 
	C34.545258,243.143982 44.582115,221.825668 56.419060,201.441376 
	C70.804436,176.668488 87.648506,153.656113 106.924416,132.336411 
	C121.842842,115.836197 137.629578,100.238365 155.163544,86.751328 
	C171.204132,74.412987 188.544006,63.710911 205.661804,52.839638 
	C225.768341,40.070263 247.671188,30.947617 270.045807,22.973888 
	C298.939728,12.676839 328.577393,5.639944 359.187408,2.914005 
	C359.843231,2.855602 360.398071,1.663327 361.000000,1.000000 
	C387.354218,1.000000 413.708466,1.000000 440.170532,1.324878 
	C441.111389,2.096347 441.905090,2.819315 442.783813,2.944262 
	C448.118134,3.702752 453.470245,4.337626 458.819305,4.990336 
	C478.522705,7.394615 497.696136,12.114270 516.658569,17.891764 
	C547.519653,27.294559 576.704041,40.418774 604.295227,57.072891 
	C628.742676,71.829445 651.685059,88.735199 671.995361,108.785011 
	C686.072266,122.681412 699.200317,137.605957 712.014587,152.697540 
	C727.767883,171.250427 740.623779,191.847595 752.069702,213.326752 
	C766.399353,240.217789 778.172852,268.149353 785.924866,297.643250 
	C789.424988,310.960052 792.331299,324.456573 794.897949,337.987122 
	C796.781982,347.919037 797.639526,358.044098 799.082336,368.064636 
	C799.186340,368.786835 800.336365,369.358398 801.000000,370.000000 
z"
      />
    </motion.svg>
  );
};
